module.exports = __webpack_public_path__ + "assets/img/9f46f93f4dc96b742067ffa4736d91cc.svg";